import { AppRoutes, RouteScrollToTop } from '@/routes';
import GlobalStyle from '@/styles/global';
import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import { MaintenanceMode } from './components/maintenance-page/maintenanceMode';
import { useCustomizationsData } from './hooks/useCustomizationsData';
import './i18n/config';
import { NavigationHistoryProvider } from './providers';

const App: FC = () => {
  const { data: customizationsData } = useCustomizationsData();
  return (
    <>
      <Helmet>
        <link rel="icon" href={customizationsData?.logos?.navbarSimpleLogo || process.env.REACT_APP_NAVBAR_SIMPLE_LOGO} />
        <meta name="description" content={process.env.REACT_APP_WEBSITE_DESCRIPTION} />
        <script src={`https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`}></script>
      </Helmet>
      <GlobalStyle />
      <MaintenanceMode>
        <BrowserRouter>
          <RouteScrollToTop>
            <NavigationHistoryProvider>
              <AppRoutes />
            </NavigationHistoryProvider>
          </RouteScrollToTop>
        </BrowserRouter>
      </MaintenanceMode>
    </>
  );
};

export default App;
